module.exports = __webpack_public_path__ + "img/1583977756.13d2f5ff.jpg";